import store from "@/redux/store";

import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Settings } from "@/views/Settings/Overview";
import {SETTINGS} from "@/actions/globalConst";
import { settingsInit, storeSettings } from '@/reducers/Settings'
import { show } from '@/reducers/Modal'

class SettingsController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null, prevType: props.type };
    this.onSaveHandler = this.onSaveHandler.bind(this);
  }

    async componentDidMount() {
        const { dispatch } = this.props;
        settingsInit();
        try {
            await store.dispatch(settingsInit()); 
            
//                const dispatch = useDispatch();
            
      } catch (err) {
        console.error('Error afhandeling', err)
      } finally {

      }            
    }
    
    async onSaveHandler(data) {
        await store.dispatch(storeSettings(data));
    }
    
  render() {
      const {SettingsReducer} = this.props;
      if(SettingsReducer?.api_state == SETTINGS.API_PENDING) {
          return (<></>);
      }
    return (
      <Settings key={SettingsReducer.key} selectedTab={SettingsReducer.selectedTab} {...this.props}  onSaveHandler={this.onSaveHandler}/>
    );
  }
}

const SettingsControllerInit = (props) => {
  return (
    <SettingsController
      {...props}
    />
  );
};

function mapStateToProps(state) {
    const {UserReducer, AuthReducer, SettingsReducer} = state;
  return {
      UserReducer,
      AuthReducer,
      SettingsReducer,
      state: {error:SettingsReducer.error}
  };
}
export default connect(mapStateToProps)(SettingsControllerInit);
